import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs';
import { LoaderService } from '../services/loader';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loader = inject(LoaderService);

  // Exclude translations, silent notifications, and static files from triggering the loader
  const isExcluded =
    loader.suppressed ||
    req.url.includes('/i18n/') ||
    req.url.includes('/assets/') ||
    req.url.includes('notify') ||
    req.url.includes('/file/') ||
    req.url.includes('/download') ||
    req.url.endsWith('.json');

  if (isExcluded) {
    return next(req);
  }

  loader.show();
  return next(req).pipe(
    finalize(() => {
      loader.hide();
    })
  );
};
